<template>
  <div>
    <SignLoading @cancel="onLoadingCancel" />
    <div v-show="debug">{{checked}}{{pos}}</div>
  </div>
</template>

<script>
// import AMapLoader from '@amap/amap-jsapi-loader';
import coordtransform from 'coordtransform';
import BMapLoader from '../utils/BMapLoader';
import SignLoading from '../components/SignLoading.vue';
import req from '../req';

/**
 * 地理围栏考勤
 */
function checkFenceAttend(data, headers = {}, cb) {
  let didCancel = false;
  req.group.isInGeoFenceAttendancePosition(data, { headers })
    .then((r1) => {
      if (didCancel) {
        return;
      }
      if (r1.code !== 0) {
        cb(r1);
        return;
      }
      cb(null, r1.data);
    })
    .catch((err) => {
      if (didCancel) {
        return;
      }
      cb(err);
    });
  return () => {
    didCancel = true;
  };
}

export default {
  components: {
    SignLoading,
  },
  data() {
    return {
      count: 0,
      checked: '',
      pos: '',
      debug: false,
      needcycle: '00',
    };
  },
  mounted() {
    const { checked, needcycle } = this.$route.query;
    this.h5Checked = '';
    this.startLocTimer = null;
    this.needcycle = needcycle;
    if (checked) {
      this.checked = checked;
      this.onFinish();
    }
    this.startLoc();
  },
  beforeRouteUpdate(to, from, next) {
    const { checked } = to.query;
    if (checked) {
      this.checked = checked;
      this.onFinish();
    }
    next();
  },
  methods: {
    async startLoc() {
      const that = this;
      try {
        // const AMap = await AMapLoader.load({
        //   key: 'e38fd0e1b995ca6aefc8e4f683a0eaa8',
        //   version: '2.0',
        //   plugins: ['AMap.Geolocation'],
        // });
        // const geolocation = new AMap.Geolocation({
        //   enableHighAccuracy: true, // 是否使用高精度定位，默认:true
        //   timeout: 1000 * 5, // 超过10秒后停止定位，默认：5s
        // });
        // geolocation.getCurrentPosition((status, result) => {
        //   if (status === 'complete') {
        //     const { position } = result;
        //     that.pos = JSON.stringify(position);
        //     that.checkAttend(position);
        //   } else {
        //     that.onErr(result);
        //   }
        // });
        const BMapGL = await BMapLoader.load({
          ak: 'kuwwhpOxIGifzaQ1qyMr2ewcFltLZ3iz',
        });
        const geolocation = new BMapGL.Geolocation();
        geolocation.getCurrentPosition((result) => {
          const status = geolocation.getStatus();
          const {
            BMAP_STATUS_SUCCESS,
            BMAP_STATUS_UNKNOWN_LOCATION,
            BMAP_STATUS_PERMISSION_DENIED,
            BMAP_STATUS_TIMEOUT,
          } = window;
          switch (status) {
            case BMAP_STATUS_SUCCESS: {
              const { point } = result;
              const [lng, lat] = coordtransform.bd09togcj02(point.lng, point.lat);
              const p = { lng, lat };
              that.pos = JSON.stringify(p);
              that.checkAttend(p);
              break;
            }
            case BMAP_STATUS_UNKNOWN_LOCATION:
              that.onErr('未知定位');
              break;
            case BMAP_STATUS_PERMISSION_DENIED:
              that.onErr('定位未授权');
              break;
            case BMAP_STATUS_TIMEOUT:
              that.onErr('定位超时');
              break;
            default:
              that.onErr(`定位失败（${status}）`);
              break;
          }
        }, {
          enableHighAccuracy: true,
          timeout: 1000 * 5,
          maximumAge: 0,
        });
        this.startLocTimer = setTimeout(() => {
          that.h5Checked = '00';
          that.onErr('定位超时');
        }, 1000 * 6);
      } catch (err) {
        this.onErr(err);
        console.log(err);
      }
    },
    checkAttend(pos) {
      const that = this;
      const {
        groupAttendanceId, sessionId, latitude, longitude,
      } = this.$route.query;
      this.cancelCheckAttend = checkFenceAttend({
        attendanceGroupId: groupAttendanceId,
        longitude,
        latitude,
        h5Longitude: pos.lng,
        h5Latitude: pos.lat,
      }, {
        sessionId,
      }, (err, res) => {
        if (err) {
          that.onErr(err);
          return;
        }
        // that.h5Checked = '00';
        // 在灰度测试情况下h5定位仅用于记录，必定返回定位失败
        that.h5Checked = that.needcycle !== '01' && res.flag ? '01' : '00';
        that.onFinish();
      });
    },
    onLoadingCancel() {
      // 中途取消，确保onFinish不触发，只发送一条message
      this.cancelCheckAttend();
      // 非作弊项目定位终止埋点通知小程序
      wx.miniProgram.postMessage({
        data: { stop: true },
      });
      wx.miniProgram.navigateBack();
    },
    onErr(err) {
      // const { checked, h5Checked } = this;
      // wx.miniProgram.postMessage({
      //   data: { err, checked, h5Checked },
      // });
      // wx.miniProgram.navigateBack();
      this.h5Checked = '00';
      this.onFinish(err);
    },
    onFinish(err) {
      const { checked, h5Checked } = this;
      console.log('onFinish:', err, { checked, h5Checked });
      if (!checked || !h5Checked) {
        return;
      }
      if (checked === '00' && h5Checked === '00') {
        wx.miniProgram.postMessage({
          data: { err, checked, h5Checked },
        });
        wx.miniProgram.navigateBack();
        return;
      }
      wx.miniProgram.postMessage({
        data: { err, checked, h5Checked },
      });
      const path = '/pages/attendance/sign/index';
      const { query } = this.$route;
      wx.miniProgram.redirectTo({
        url: `${path}?${Object.keys(query).map((k) => `${k}=${query[k]}`).join('&')}`,
      });
    },
  },
};
</script>
